import { HTMLAttributes } from 'react'
import {
  DisplayProps,
  LayoutProps,
  MarginProps,
  PositionProps,
} from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import INTERNALxTag from 'designSystem/components/internal/INTERNALxTag'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSIcon from '../PDSIcon/PDSIcon'

type TagSize = 'sm' | 'md' | 'lg'
type TagVariant = 'alert' | 'info' | 'neutral' | 'success' | 'warning'

type BaseProps = HTMLAttributes<HTMLSpanElement> &
  DisplayProps &
  MarginProps &
  LayoutProps &
  PositionProps &
  TestIdProps

type Props = {
  canClose?: boolean
  onClose?: () => void
  size?: TagSize
  showBorder?: boolean
  variant?: TagVariant
} & BaseProps

export default function PDSTag({
  canClose = true,
  onClose,
  size = 'md',
  showBorder = true,
  testId,
  variant = 'neutral',
  ...props
}: Props) {
  const closeColor = CLOSE_COLOR[variant] ?? CLOSE_COLOR.neutral
  const showCloseButton = !!onClose && canClose

  return (
    <INTERNALxTag
      {...props}
      paddingX={SIZE.s12}
      showBorder={showBorder}
      size={size}
      variant={variant}
    >
      {props.children}

      {showCloseButton && (
        <PDSIcon
          color={closeColor}
          marginLeft={SIZE.s4}
          name="close"
          onClick={onClose}
          style={{ cursor: 'pointer' }}
          size="sm"
        />
      )}
    </INTERNALxTag>
  )
}

const CLOSE_COLOR = {
  alert: COLOR.alert400,
  info: COLOR.info400,
  neutral: COLOR.neutral600,
  success: COLOR.success400,
  warning: COLOR.warning400,
}
